export default {"src":"/_next/static/media/pls.a97f40f2.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};